import { motion } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';

export const StyledBackdrop = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => rgba(theme.colors.cross.deepBlu, 0.3)};
`;
